var exports = {};
var round = Math.round;
exports = function (it) {
  var value = round(it);
  return value < 0 ? 0 : value > 255 ? 255 : value & 255;
};
export default exports;